import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const LogoWhiteShape = ({
  width,
  height,
  fillColor = '#fff',
  style
}: BaseSVGType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="200 200 600 600"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      fill={fillColor}
    >
      <path
        className="cls-1"
        d="M744.7,447.25c-.47,38.5-8.68,75.27-24.54,109.12-13.41,28.8-32.43,55.78-56.49,80.24-42.37,43.16-91.92,70.22-125.92,85.37-11.91,5.29-24.77,8.05-37.79,8.05s-25.88-2.76-37.79-8.05c-34.01-15.15-83.47-42.21-125.92-85.37-24.06-24.46-43.08-51.44-56.49-80.24-15.86-33.85-24.06-70.61-24.46-109.12-.32-20.91,3.71-41.74,11.83-61.07,7.81-18.38,19.33-34.95,33.85-48.68,14.28-13.41,31.16-23.75,49.63-30.38,19.25-6.86,39.61-9.55,60.51-8.05,25.15,1.82,49.18,10.1,69.91,23.86,9.68,6.42,10.37,20.45,1.62,28.1l-34.69,30.33c-3.94,3.47-5.36,8.99-3.55,13.89l44.5,123.71-78.03-92.47c-3.16-3.71-8.21-5.36-12.94-4.1l-43.16,11.44c-5.58,1.48-9.47,6.53-9.47,12.31v46.16c0,5.57,3.63,10.5,8.96,12.14l129.03,39.77h-101.3c-5.68,0-10.67,3.77-12.23,9.23l-12.31,43.23c-1.97,6.79,1.89,13.81,8.68,15.7l44.58,13.02c4.18,1.18,8.68.24,11.91-2.6l68.09-59.49-6.86,87.97c-.32,3.71,2.6,6.86,6.31,6.86h19.57c3.71,0,6.63-3.16,6.31-6.86l-6.87-87.97,68.09,59.49c3.23,2.84,7.73,3.79,11.91,2.6l44.66-13.02c6.71-1.89,10.57-8.92,8.68-15.7l-12.39-43.25c-1.56-5.45-6.55-9.21-12.22-9.21h-101.3l129.03-39.77c5.33-1.64,8.96-6.57,8.96-12.14v-46.16c0-5.77-3.89-10.83-9.47-12.31l-43.16-11.44c-4.73-1.26-9.78.39-12.94,4.1l-77.95,92.47,44.5-123.71c1.74-4.89.31-10.41-3.63-13.89l-34.68-30.33c-8.75-7.65-8.06-21.68,1.63-28.1,20.75-13.76,44.81-22.04,69.9-23.86,20.99-1.5,41.34,1.18,60.51,8.05,37.71,13.49,67.93,42.21,83.47,79.06,8.13,19.33,12.23,40.16,11.91,61.07Z"
      />
    </svg>
  );
};

export default LogoWhiteShape;
